module.exports = __webpack_public_path__ + "static/media/invalid.a1b27561.png";